module.exports = __webpack_public_path__ + "img/Kieran Tierney.8ad64dc9.png";